import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { ErforderlichesDokumentsService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [ErforderlichesDokumentsService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class ErforderlichesDokumentsServiceModule {}
